<template>
  <bb-modal
    visible
    flavor="card"
    public-size="m"
    full-mobile
    @close="onClose"
  >
    <template #heading>
      <span class="f-small f-color-blue">
        {{ title }}
      </span>
    </template>
    <bb-icon
      class="m-x-55 m-x-md-80 m-t-10 m-b-30 m-b-md-25"
      name="illustration-exclamation-mark"
      size="auto"
      fill="original"
    />
    <p class="m-b-20 align-center f-color-gray">
      {{ errorText }}
    </p>
    <template #footer>
      <bb-button
        class="w-100"
        label="Log in again"
        corner="sharpMobileOnly"
        @click="$emit('initiate-authentication')"
      />
    </template>
  </bb-modal>
</template>
<script>
  import '@bigbank/interface-components/dist/svg/illustration/exclamation-mark';
  import { BbModal, BbIcon, BbButton } from '@bigbank/interface-components';

  export default {
    name: 'smart-id-plus-error-modal',
    components: {
      BbModal,
      BbIcon,
      BbButton,
    },
    props: {
      title: String,
      errorText: String,
    },
    methods: {
      onClose() {
        this.$emit('update:title', null);
        this.$emit('update:error-text', null);
      },
    },
  };
</script>
